"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonForms = exports.ResolvedJsonFormsDispatch = exports.JsonFormsDispatch = exports.ResolvedJsonFormsDispatchRenderer = exports.JsonFormsDispatchRenderer = void 0;
var tslib_1 = require("tslib");
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var maxBy_1 = tslib_1.__importDefault(require("lodash/maxBy"));
var react_1 = tslib_1.__importStar(require("react"));
var UnknownRenderer_1 = require("./UnknownRenderer");
var core_1 = require("@jsonforms/core");
var JsonFormsContext_1 = require("./JsonFormsContext");
var JsonFormsDispatchRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(JsonFormsDispatchRenderer, _super);
    function JsonFormsDispatchRenderer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            id: core_1.isControl(props.uischema)
                ? core_1.createId(props.uischema.scope)
                : undefined,
        };
        return _this;
    }
    JsonFormsDispatchRenderer.prototype.componentWillUnmount = function () {
        if (core_1.isControl(this.props.uischema)) {
            core_1.removeId(this.state.id);
        }
    };
    JsonFormsDispatchRenderer.prototype.render = function () {
        var _a = this.props, schema = _a.schema, uischema = _a.uischema, path = _a.path, enabled = _a.enabled, renderers = _a.renderers, cells = _a.cells;
        return (react_1.default.createElement(TestAndRender, { uischema: uischema, schema: schema, path: path, enabled: enabled, renderers: renderers, cells: cells, id: this.state.id }));
    };
    return JsonFormsDispatchRenderer;
}(react_1.default.Component));
exports.JsonFormsDispatchRenderer = JsonFormsDispatchRenderer;
var TestAndRender = react_1.default.memo(function (props) {
    var renderer = react_1.useMemo(function () { return maxBy_1.default(props.renderers, function (r) { return r.tester(props.uischema, props.schema); }); }, [props.renderers, props.uischema, props.schema]);
    if (renderer === undefined ||
        renderer.tester(props.uischema, props.schema) === -1) {
        return react_1.default.createElement(UnknownRenderer_1.UnknownRenderer, { type: 'renderer' });
    }
    else {
        var Render = renderer.renderer;
        return (react_1.default.createElement(Render, { uischema: props.uischema, schema: props.schema, path: props.path, enabled: props.enabled, renderers: props.renderers, cells: props.cells, id: props.id }));
    }
});
/**
 * @deprecated Since Version 3.0 this optimization renderer is no longer necessary.
 * Use `JsonFormsDispatch` instead.
 * We still export it for backward compatibility
 */
var ResolvedJsonFormsDispatchRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(ResolvedJsonFormsDispatchRenderer, _super);
    function ResolvedJsonFormsDispatchRenderer(props) {
        return _super.call(this, props) || this;
    }
    return ResolvedJsonFormsDispatchRenderer;
}(JsonFormsDispatchRenderer));
exports.ResolvedJsonFormsDispatchRenderer = ResolvedJsonFormsDispatchRenderer;
var useJsonFormsDispatchRendererProps = function (props) {
    var ctx = JsonFormsContext_1.useJsonForms();
    return {
        schema: props.schema || ctx.core.schema,
        uischema: props.uischema || ctx.core.uischema,
        path: props.path || '',
        enabled: props.enabled,
        rootSchema: ctx.core.schema,
        renderers: props.renderers || ctx.renderers,
        cells: props.cells || ctx.cells,
    };
};
exports.JsonFormsDispatch = react_1.default.memo(function (props) {
    var renderProps = useJsonFormsDispatchRendererProps(props);
    return react_1.default.createElement(JsonFormsDispatchRenderer, tslib_1.__assign({}, renderProps));
});
/**
 * @deprecated Since Version 3.0 this optimization component is no longer necessary.
 * Use `JsonFormsDispatch` instead.
 * We still export it for backward compatibility
 */
exports.ResolvedJsonFormsDispatch = react_1.default.memo(function (props) {
    var renderProps = useJsonFormsDispatchRendererProps(props);
    return react_1.default.createElement(ResolvedJsonFormsDispatchRenderer, tslib_1.__assign({}, renderProps));
});
var JsonForms = function (props) {
    var ajv = props.ajv, data = props.data, schema = props.schema, uischema = props.uischema, renderers = props.renderers, cells = props.cells, onChange = props.onChange, config = props.config, uischemas = props.uischemas, readonly = props.readonly, validationMode = props.validationMode, i18n = props.i18n;
    var schemaToUse = react_1.useMemo(function () { return (schema !== undefined ? schema : core_1.Generate.jsonSchema(data)); }, [schema, data]);
    var uischemaToUse = react_1.useMemo(function () {
        return typeof uischema === 'object' ? uischema : core_1.Generate.uiSchema(schemaToUse);
    }, [uischema, schemaToUse]);
    return (react_1.default.createElement(JsonFormsContext_1.JsonFormsStateProvider, { initState: {
            core: {
                ajv: ajv,
                data: data,
                schema: schemaToUse,
                uischema: uischemaToUse,
                validationMode: validationMode
            },
            config: config,
            uischemas: uischemas,
            renderers: renderers,
            cells: cells,
            readonly: readonly,
            i18n: i18n
        }, onChange: onChange },
        react_1.default.createElement(exports.JsonFormsDispatch, null)));
};
exports.JsonForms = JsonForms;
//# sourceMappingURL=JsonForms.js.map